import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import { fetch_all, fetch_one } from '../../lib/server_helper';
import { checkAllowed } from '../../lib/permission';
import { loginAtom } from '../../lib/auth';

import DraftsIcon from '@mui/icons-material/Drafts';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import {
  Box,
  CircularProgress,
  Grid
} from '@mui/material';

import {
  Typography
} from '../../components/interface';

import { getCookie, setCookie } from 'react-use-cookie';

import { Company } from '../../models/Company';
import { Project } from '../../models/Project';

type Props = {};

export const DashboardOrganiser: FunctionComponent<Props> = () => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);

  const [companyId, setCompanyId] = useState<number>();
  const [projectIntId, setProjectIntId] = useState<number>();
  const [projectExtId, setProjectExtId] = useState<number>();
  const [projects, setProjects] = useState<Project[]>([]);
  const [sentLoader, setSentLoader] = useState<boolean>(true);
  const [dbSent, setDbSent] = useState<number>();
  const [openLoader, setOpenLoader] = useState<boolean>(true);
  const [dbOpen, setDbOpen] = useState<number>();
  const [surveysLoader, setSurveysLoader] = useState<boolean>(true);
  const [dbSurveys, setDbSurveys] = useState<number>();
  const [npsIntLoader, setNpsIntLoader] = useState<boolean>(true);
  const [dbNpsInt, setDbNpsInt] = useState<{score: number, detractors: number, promotors: number, user_count: number}>();
  const [npsExtLoader, setNpsExtLoader] = useState<boolean>(true);
  const [dbNpsExt, setDbNpsExt] = useState<{score: number, detractors: number, promotors: number, user_count: number}>();
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('cribeon_active_company_id') || '');

  // Settings

  useEffect(() => {
    if (!!activeCompany) statSent();
    if (!!activeCompany) statOpen();
    if (!!activeCompany) statSurveys();
    if (!!activeCompany) statNpsInt();
    if (!!activeCompany) statNpsExt();
  }, [activeCompany]);

  const statNpsExt = () => {
    if (!!activeCompany) {
      fetch_one<{custom_result: {score: number, detractors: number, promotors: number, user_count: number}}>('/nl/v3/objects/custom_action', {
        object: 'company',
        class_action: 'custom_api_statistical_query',
        id: activeCompany,
        q: 'nps_ext'
      }, (ob, complete_data) => {
        setNpsExtLoader(false);
        if (!!ob.custom_result) setDbNpsExt(ob.custom_result);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      
    }
  };

  const statNpsInt = () => {
    if (!!activeCompany) {
      fetch_one<{custom_result: {score: number, detractors: number, promotors: number, user_count: number}}>('/nl/v3/objects/custom_action', {
        object: 'company',
        class_action: 'custom_api_statistical_query',
        id: activeCompany,
        q: 'nps_int'
      }, (ob, complete_data) => {
        setNpsIntLoader(false);
        if (!!ob.custom_result) setDbNpsInt(ob.custom_result);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      
    }
  };

  const statOpen = () => {
    if (!!activeCompany) {
      fetch_one<{custom_result: number}>('/nl/v3/objects/custom_action', {
        object: 'company',
        class_action: 'custom_api_statistical_query',
        id: activeCompany,
        q: 'open_emails'
      }, (ob, complete_data) => {
        setOpenLoader(false);
        setDbOpen(ob.custom_result);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      
    }
  };

  const statSent = () => {
    if (!!activeCompany) {
      fetch_one<{custom_result: number}>('/nl/v3/objects/custom_action', {
        object: 'company',
        class_action: 'custom_api_statistical_query',
        id: activeCompany,
        q: 'sent_emails'
      }, (ob, complete_data) => {
        setSentLoader(false);
        setDbSent(ob.custom_result);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      
    }
  };

  const statSurveys = () => {
    if (!!activeCompany) {
      fetch_one<{custom_result: number}>('/nl/v3/objects/custom_action', {
        object: 'company',
        class_action: 'custom_api_statistical_query',
        id: activeCompany,
        q: 'surveys'
      }, (ob, complete_data) => {
        setSurveysLoader(false);
        setDbSurveys(ob.custom_result);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      
    }
  };







  const statBlock = (icon: string, title: string, stat: any, bordercolor: string, backcolor: string, extra_line?: any) => {
    return <Box sx={{
      padding: 1,
      border: `1px solid ${bordercolor}`,
      borderRadius: 1,
      backgroundColor: backcolor
    }}>
      <Box sx={{
        display: 'inline-block',
        width: '50%',
        height: '100%',
        // borderRight: '2px solid #2b4699',
        // padding: 1
      }}>
        <Box sx={{
          borderRight: `2px solid ${bordercolor}`,
          padding: 1,
          textAlign: 'center'
        }}>
          {icon === 'mail' && <MarkEmailReadIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'opened' && <DraftsIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'surveys' && <UploadFileIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'nps_happy' && <SentimentVerySatisfiedIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'nps_neutral' && <SentimentNeutralIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'nps_unhappy' && <SentimentVeryDissatisfiedIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'loading' && <CircularProgress sx={{color: 'white', width: '60px', height: '60px'}} />}
        </Box>
      </Box>
      <Box sx={{
        display: 'inline-block',
        width: '50%',
        height: '100%',
        // padding: 1
      }}>
        <Box sx={{
          padding: 1
        }}>
          <Typography sx={{
            color: 'white',
            fontSize: '0.7rem',
            textAlign: 'center'
          }}>{title}</Typography>
          <Typography sx={{
            color: 'white',
            fontSize: '3rem',
            textAlign: 'center'
          }}>{stat}</Typography>
          {!!extra_line && extra_line}
        </Box>
      </Box>
    </Box>;
  }
  const statBlock3 = (icon: string, title: string, stat: any, bordercolor: string, backcolor: string, extra_line?: any) => {
    return <Box sx={{
      padding: 1,
      border: `1px solid ${bordercolor}`,
      borderRadius: 1,
      backgroundColor: backcolor
    }}>
      <Box sx={{
        display: 'inline',
        width: '100%',
        // borderRight: '2px solid #2b4699',
        // padding: 1
      }}>
        <Box sx={{
          padding: 1,
          textAlign: 'center'
        }}>
          {icon === 'mail' && <MarkEmailReadIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'opened' && <DraftsIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'surveys' && <UploadFileIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'nps_happy' && <SentimentVerySatisfiedIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'nps_neutral' && <SentimentNeutralIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'nps_unhappy' && <SentimentVeryDissatisfiedIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
          {icon === 'loading' && <CircularProgress sx={{color: 'white', width: '60px', height: '60px'}} />}
        </Box>
      </Box>
      <Box sx={{
        display: 'inline',
        width: '100%',
        // padding: 1
      }}>
        <Box sx={{
          borderTop: `2px solid ${bordercolor}`,
          borderBottom: `2px solid ${bordercolor}`,
          padding: 1
        }}>
          <Typography sx={{
            color: 'white',
            fontSize: '0.7rem',
            textAlign: 'center'
          }}>{title}</Typography>
          <Typography sx={{
            color: 'white',
            fontSize: '3rem',
            textAlign: 'center'
          }}>{stat}</Typography>
        </Box>
      </Box>
      <Box sx={{
        display: 'inline',
        width: '100%',
        // padding: 1
      }}>
        <Box sx={{
          padding: 1
        }}>
          {!!extra_line && extra_line}
        </Box>
      </Box>
    </Box>;
  }


  return <>
    <Grid container spacing="8">
      <Grid item xs={12} md={4}>
        {statBlock(!!sentLoader ? 'loading' : 'mail', 'Sent emails', !sentLoader ? dbSent : '&nbsp;', '#2b4699', '#4e76ed')}
      </Grid>
      <Grid item xs={12} md={4}>
        {statBlock(!!openLoader ? 'loading' : 'opened', 'Opened emails', !openLoader ? dbOpen : '&nbsp;', '#1a631a', '#86b586')}
      </Grid>
      <Grid item xs={12} md={4}>
        {statBlock(!!surveysLoader ? 'loading' : 'surveys', 'Surveys submitted', !surveysLoader ? dbSurveys : '&nbsp;', '#d67411', '#d9a775')}
      </Grid>
      
      <Grid item xs={12} md={4}>
        {statBlock3(
          !!npsIntLoader ? 'loading' : (((dbNpsInt?.score || 0) * 100) < -10 ? 'nps_unhappy' : (((dbNpsInt?.score || 0) * 100) < 11 ? 'nps_neutral' : 'nps_happy')), 
          'NPS - internal', 
          !npsIntLoader ? ((dbNpsInt?.score || 0) * 100) : '&nbsp;', 
          '#efefef', 
          (((dbNpsInt?.score || 0) * 100) < -10 ? '#de6957' : (((dbNpsInt?.score || 0) * 100) < 11 ? '#e6a147' : '#226e32')),
          <><Typography sx={{fontSize: '0.8rem', color: 'white', textAlign: 'center', lineHeight: '16px', marginTop: 1, backgroundColor: 'rgba(255, 255, 255, 0.2)', padding: 1}}>
            <SentimentVeryDissatisfiedIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'red'}} />&nbsp;{dbNpsInt?.detractors || 0}<br/>
            <SentimentNeutralIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'gold'}} />&nbsp;{(dbNpsInt?.user_count || 0) - (dbNpsInt?.detractors || 0) - (dbNpsInt?.promotors || 0)}<br/>
            <SentimentVerySatisfiedIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'green'}} />&nbsp;{dbNpsInt?.promotors || 0}
          </Typography></>
        )}
      </Grid>
      <Grid item xs={12} md={4}>
        <Box sx={{
          padding: 1,
          border: `1px solid black`,
          borderRadius: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }}>
          <Box sx={{
            display: 'inline',
            width: '100%',
            // borderRight: '2px solid #2b4699',
            // padding: 1
          }}>
            <Box sx={{
              padding: 1,
              textAlign: 'center'
            }}>
              <Typography variant="subtitle1" sx={{textDecoration: 'underline'}}>Legende</Typography>
              <Typography sx={{fontSize: '0.8rem', textAlign: 'left', lineHeight: '16px'}}>
                <SentimentVeryDissatisfiedIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'red'}} />&nbsp;Men zal actief je merk weren. [-100, -10[
              </Typography>
              <Typography sx={{fontSize: '0.8rem', textAlign: 'left', lineHeight: '16px'}}>
                <SentimentNeutralIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'gold'}} />&nbsp;Noch goed, noch slecht. Kan beter. [-10, 10]
              </Typography>
              <Typography sx={{fontSize: '0.8rem', textAlign: 'left', lineHeight: '16px'}}>
                <SentimentVerySatisfiedIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'green'}} />&nbsp;Men promoot je merk. Goed bezig. ]10, 100]
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={4}>
        {statBlock3(
          !!npsExtLoader ? 'loading' : (((dbNpsExt?.score || 0) * 100) < -10 ? 'nps_unhappy' : (((dbNpsExt?.score || 0) * 100) < 11 ? 'nps_neutral' : 'nps_happy')), 
          'NPS - external', 
          !npsExtLoader ? ((dbNpsExt?.score || 0) * 100) : '&nbsp;', 
          '#000000', 
          (((dbNpsExt?.score || 0) * 100) < -10 ? '#de6957' : (((dbNpsExt?.score || 0) * 100) < 11 ? '#e6a147' : '#226e32')),
          <><Typography sx={{fontSize: '0.8rem', color: 'white', textAlign: 'center', lineHeight: '16px', marginTop: 1, backgroundColor: 'rgba(255, 255, 255, 0.2)', padding: 1}}>
            <SentimentVeryDissatisfiedIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'red'}} />&nbsp;{dbNpsExt?.detractors || 0}<br/>
            <SentimentNeutralIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'gold'}} />&nbsp;{(dbNpsExt?.user_count || 0) - (dbNpsExt?.detractors || 0) - (dbNpsExt?.promotors || 0)}<br/>
            <SentimentVerySatisfiedIcon sx={{margin: 0.5, marginBottom: -0.5, color: 'green'}} />&nbsp;{dbNpsExt?.promotors || 0}
          </Typography></>
        )}
      </Grid>
    </Grid>
  </>;
}
